import { IDSLink as i } from "./link-element.js";
import { registerComponent as r } from "../../utilities/utils.js";
import "../grid/column/register.js";
import "../grid/row/register.js";
r("ids-link", i);